/**
 * TabNav Component - Navigation tabs
 */

import type { Tab } from '../../types'

interface TabNavProps {
  tabs: Tab[]
  activeTab: string
  onTabChange: (tabId: string) => void
}

export function TabNav({ tabs, activeTab, onTabChange }: TabNavProps) {
  return (
    <nav className="flex border-b border-term-border bg-term-bg px-2">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`term-tab ${activeTab === tab.id ? 'term-tab-active' : ''}`}
        >
          <span className="text-term-textDim text-xs mr-1.5">[{tab.shortcut}]</span>
          {tab.label}
        </button>
      ))}
    </nav>
  )
}
